<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-card>
        <v-card-title>
          <div>
            <h1 class="title">Password</h1>
          </div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card>
          <form @submit.prevent="formSubmit">
            <v-card-text>
              <v-container fluid grid-list-md>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-text-field required hint="You must provide your current password in order to change it." persistent-hint label="Current password" v-model="user.old_password" v-validate="'required'" :error-messages="errors.collect('current password')" data-vv-name="current password" :append-icon="e1 ? 'visibility' : 'visibility_off'" :append-icon-cb="() => (e1 = !e1)" :type="e1 ? 'password' : 'text'"></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field required name="newPassword" label="New password" v-model="user.new_password" v-validate="'required|min:6'" :error-messages="errors.collect('new password')" data-vv-name="new password" :append-icon="e2 ? 'visibility' : 'visibility_off'" :append-icon-cb="() => (e2 = !e2)" :type="e2 ? 'password' : 'text'"></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field required label="Password confirmation" v-model="user.retype_password" v-validate="'required|confirmed:newPassword|min:6'" :error-messages="errors.collect('password confirmation')" data-vv-name="password confirmation" :append-icon="e3 ? 'visibility' : 'visibility_off'" :append-icon-cb="() => (e3 = !e3)" :type="e3 ? 'password' : 'text'"></v-text-field>
                      </v-flex>
                    </v-layout>
                    <div>
                      <span class="caption">*After a successful password update, you will be redirected to the login page where you can log in with your new password</span>
                    </div>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn to="/profile">cancel</v-btn>
              <v-btn dark color="accent" @click="formSubmit" :loading="getLoading" :disable="getLoading">change password
              </v-btn>
            </v-card-actions>
          </form>
        </v-card>
      </v-card>
    </v-flex>
    <v-snackbar :color="color" :timeout="timeout" bottom right v-model="snackbar">
      {{ text }}
      <v-btn flat dark @click.native="snackbar = false">
        <v-icon>clear</v-icon>
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'change-password',
  $_veeValidate: {
    validator: 'new'
  },
  data () {
    return {
      e1: true,
      e2: true,
      e3: true,
      loader: null,
      snackbar: false,
      y: 'top',
      mode: '',
      timeout: 5000,
      text: '',
      color: '',
      user: {
        old_password: '',
        new_password: '',
        retype_password: ''
      }
    }
  },
  computed: {
    ...mapGetters(['getLoading', 'getResponse'])
  },
  methods: {
    ...mapActions(['changePassword', 'signOut']),

    formSubmit: function () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.changePassword(this.user).then(() => {
            let response = this.getResponse
            this.snackbar = true
            this.text =
              response.status === 200
                ? 'Changed successfully. You will be redirected to sign in page in a few seconds...'
                : response.data.message
            this.color = response.status === 200 ? 'success' : 'error'
            if (response.status === 200) {
              setTimeout(() => {
                this.signOut()
              }, 2000)
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/user/ChangePassword.vue